/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bills: NonNullable<unknown> }} Partner_Home_Last_Month_NoteInputs */



/**
* | output |
* | --- |
* | "{bills} closed" |
*
* @param {Partner_Home_Last_Month_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_last_month_note = /** @type {((inputs: Partner_Home_Last_Month_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Last_Month_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.bills} abgeschlossen`)
	return /** @type {LocalizedString} */ (`${i?.bills} closed`)
});